import { Box, BoxProps } from "@chakra-ui/react";

interface ProgressBarProps {
    value: number;
    max: number;
    color: string;
}

export function ProgressBar({ value, max, color }: ProgressBarProps) {
    const pct = Math.min((value / max) * 100, 100);
    return (
        <Box w="full" h="6px" bg="gray.100" borderRadius="full" overflow="hidden">
            <Box
                h="full"
                w={`${pct}%`}
                bg={pct > 80 ? "#ef4444" : color}
                borderRadius="full"
                transition="width 0.6s ease"
            />
        </Box>
    );
}

export function Card({ children, ...props }: BoxProps) {
    return (
        <Box
            bg="white"
            borderRadius="20px"
            p={6}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="0 2px 16px rgba(0,0,0,0.05)"
            minW={0}
            {...props}
        >
            {children}
        </Box>
    );
}

// export function SepaTag() {
//   return (
//     <Box
//       display="inline-flex"
//       alignItems="center"
//       bg="blue.50"
//       borderRadius="6px"
//       px="6px"
//       py="2px"
//       fontSize="9px"
//       fontWeight="800"
//       color="blue.700"
//       letterSpacing="wider"
//     >
//       SEPA
//     </Box>
//   );
// }

export function DownloadIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 1v9M4.5 6.5 8 10l3.5-3.5M2 13h12"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}